import { InteractionMetric, ITimeMetric } from "@edgetier/watchtower-types";

/**
 * Check if a given metric is a time metric.
 * @param metric Interaction metric.
 * @returns True if the metric is a time metric, false otherwise.
 */
export const isTimeMetric = (metric: InteractionMetric): metric is ITimeMetric => {
    switch (metric) {
        case InteractionMetric.FirstResponseTime:
        case InteractionMetric.HandlingTime:
        case InteractionMetric.AverageResponseTime:
        case InteractionMetric.AgentFirstResponseTime:
        case InteractionMetric.QueueTime:
            return true;
        default:
            return false;
    }
};
